import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { GridService } from './grid.service';
import { DictionaryService } from './dictionary.service';

@Injectable()
export class AutomaticReportsService {
  public automaticReportsModel: any;
  public scheduleTypes: Array<any>;
  public reportTypes: Array<any>;
  public assignedColumnsSettings: Array<any>;

  constructor(
    private userService: UserService,
    private gridService: GridService,
    private dictionaryService: DictionaryService
  ) {
    this.scheduleTypes = [
      { id: 1, label: this.dictionaryService.get('DAILY'), name: 'daily' },
      { id: 2, label: this.dictionaryService.get('WEEKLY'), name: 'weekly' },
      { id: 3, label: this.dictionaryService.get('MONTHLY'), name: 'monthly' },
    ];

    this.reportTypes = [
      { id: 1, label: this.dictionaryService.get('DEMAND'), name: 'demand' },
      { id: 2, label: this.dictionaryService.get('PUBLISHER'), name: 'supply' },
    ];

    this.automaticReportsModel = {
      id: -1,
      reportName: '',
      isActive: true,
      frequency: -1,
      reportType: 2,
      networkId: this.userService.userData.networkId,
      networkName: this.userService.userData.networkName,
      emailString: '',
      email: [],
    };

    this.assignedColumnsSettings = [
      { key: '$$selected', label: 'ASSIGNED', width: 192, resizable: true },
      { key: 'active', label: 'ACTIVE' },
      { key: 'id', label: 'ITEM_ID', filterType: 'INPUT', primaryKey: true },
      { key: 'name', label: 'ITEM_NAME', filterType: 'INPUT' },
      {
        key: 'environment',
        label: 'ENVIRONMENT_SHORT',
        filterType: 'SELECT',
        parseFunction: this.gridService.parseMultipleEnvironments,
        parseTooltipFunction: this.gridService.parseMultipleEnvironmentsTooltip,
      },
      { key: 'type', label: 'TYPE', filterType: 'SELECT' },
      { key: 'partner', label: 'PARTNER_NAME', filterType: 'SELECT' },
    ];
  }
}
